/* @flow weak */
import AvatarActions from 'actions/AvatarActions';
import AvatarStore from 'stores/AvatarStore';
import React from 'react';
import Dialog from 'components/Dialog.jsx';
import List from 'components/List.jsx';
import ListItem from 'components/ListItem.jsx';
import BoxBody from 'components/BoxBody.jsx';
import Image from 'components/Image.jsx';
import Glyph from 'components/Glyph.jsx';
import cx from 'classnames';
import './styles/GroupAvatarPicker.scss';

class GroupAvatarPicker extends React.Component {
  static propTypes = {
    onSelect: React.PropTypes.func,
    selectedAvatar: React.PropTypes.number,
  };

  static prefetch = [
    function() {
      if (!AvatarStore.areGroupAvatarsLoaded()) {
        return AvatarActions.loadGroupAvatars();
      }
    },
  ];

  handleSelection = (avatar) => {
    this.props.onRequestHide();
    if (this.props.onSelect) {
      this.props.onSelect(avatar);
    }
  };

  renderAvatar = (avatar, index) => {
    const selected = this.props.selectedAvatar === avatar.id;

    const selectedGlyph = selected ?
      <div className="GroupAvatarPicker-avatar-selectedCheck">
        <Glyph name="check" size="medium" />
      </div>
      : null;

    return (
      <ListItem
        key={index}
        className={cx('GroupAvatarPicker-avatar', { selected })}
        onClick={() => this.handleSelection(avatar)}>
        <Image className="GroupAvatarPicker-avatar-image" src={avatar.getUrl()} />
        {selectedGlyph}
      </ListItem>
    );
  };

  render() {
    return (
      <Dialog
        eventScreenName="GroupAvatarPicker"
        {...this.props}
        title="Select a class icon">
        <BoxBody divided>
          <List>
            {AvatarStore.getGroupAvatars().map(this.renderAvatar)}
          </List>
        </BoxBody>
      </Dialog>
    );
  }
}

export default GroupAvatarPicker;



// WEBPACK FOOTER //
// ./src/groups/components/GroupAvatarPicker.jsx